import React from 'react';
import { motion } from 'framer-motion';
import { UserPlus, Smartphone, Sparkles } from 'lucide-react';
const steps = [{
  id: '01',
  title: 'Regístrate',
  description: 'Crea tu perfil en segundos.',
  icon: UserPlus
}, {
  id: '02',
  title: 'Baja tu App',
  description: 'Instala tu APP, y llévala a todas partes.',
  icon: Smartphone
}, {
  id: '03',
  title: 'Úsala',
  description: 'Tendrás beneficios en forma inmediata.',
  icon: Sparkles
}];
export function HowItWorks() {
  return <section className="py-24 bg-gradient-to-b from-gaming-dark to-[#0f1435] relative overflow-hidden" data-id="element-112">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px]" data-id="element-113"></div>

      <div className="container mx-auto px-4 max-w-7xl relative z-10" data-id="element-114">
        <div className="text-center mb-20" data-id="element-115">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-white uppercase tracking-wider" data-id="element-116">
            Cómo <span className="text-gaming-purple" data-id="element-117">Funciona</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-118">
            Tu camino hacia la gloria en tres simples pasos. Empieza hoy mismo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-119">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gradient-to-r from-gaming-cyan via-gaming-purple to-gaming-cyan opacity-20 -translate-y-1/2" data-id="element-120"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="relative flex flex-col items-center text-center" data-id="element-121">
              <div className="w-24 h-24 bg-gaming-card rounded-full border-2 border-gaming-cyan/30 flex items-center justify-center mb-8 relative z-10 group hover:border-gaming-cyan hover:shadow-[0_0_20px_rgba(0,217,255,0.4)] transition-all duration-300" data-id="element-122">
                <step.icon className="w-10 h-10 text-white group-hover:text-gaming-cyan transition-colors" data-id="element-123" />
                <div className="absolute -top-3 -right-3 w-10 h-10 bg-gaming-purple rounded-full flex items-center justify-center text-white font-bold font-display border-2 border-gaming-dark" data-id="element-124">
                  {step.id}
                </div>
              </div>

              <h3 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide" data-id="element-125">
                {step.title}
              </h3>

              <p className="text-gray-400 leading-relaxed px-4" data-id="element-126">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}